import DataActions from '../../enums/ActionTypes/DataActions'
import EditsActions from '../../enums/ActionTypes/EditsActions'
import MapActions from '../../enums/ActionTypes/MapActions'
import {ComponentTarget} from '../../enums/ComponentTarget'
import {IActionDispatcher, IEditsDispatcher, IPaylodAction} from '../../interfaces/dispatchers'
import {ITableProps} from '../../interfaces/models'
import {IdFeature, IFeatureLayerInfos, IStore, TypeKeyIdFeaturesPair} from '../../interfaces/reducers'
import {ISourceApplyEdits} from '../../interfaces/services'
import {Feature, FeatureLayerInfo, FeatureStatus} from '../../models'
import {getMapService} from '../../reducers/map'
import {ServiceHub} from '../../ServiceHub'

export class EditsDispatcher implements IEditsDispatcher {
  constructor() {
    this.applyChanges = this.applyChanges.bind(this)
    this.cancel = this.cancel.bind(this)
    this.applyEdits = this.applyEdits.bind(this)
    this.setOriginals = this.setOriginals.bind(this)
  }

  public setOriginals(originalFeatures: TypeKeyIdFeaturesPair, callback: () => void) {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IStore) => {
      const editsStore = getStore().edits
      const originals: TypeKeyIdFeaturesPair = {}
      for (const id in originalFeatures) {
        const idFeatures: IdFeature = {...editsStore.originals[id]}
        for (const key in originalFeatures[id]) {
          const f = originalFeatures[id][key]
          if (f.status == FeatureStatus.Modified) {
            alert("Can't set originals from modified entity")
            throw new Error('Cant set originals from modified entity')
          }
          idFeatures[f.getId()] = f.clone()
        }
        originals[id] = idFeatures
      }

      dispatch({
        type: EditsActions.ADD_OR_UPDATE_SOURCE_ORIGINALS,
        payload: originals
      })
      setTimeout(() => {
        callback()
      }, 100)
    }
  }

  protected dispatchAll(sourcesEdits: TypeKeyIdFeaturesPair, targets?: number) {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IStore) => {
      if (!targets || targets & ComponentTarget.Map) {
        dispatch(this.applyMapChanges(sourcesEdits))
      }
      if (!targets || targets & ComponentTarget.SingleView) {
        dispatch(this.applySingleViewChanges(sourcesEdits))
      }
      if (!targets || targets & ComponentTarget.SingleCreator) {
        dispatch(this.applySingleCreatorChanges(sourcesEdits))
      }
      if (!targets || targets & ComponentTarget.Table) {
        dispatch(this.applyTableChanges(sourcesEdits))
      }
      if (!targets || targets & ComponentTarget.Popup) {
        dispatch(this.applyPopupChanges(sourcesEdits))
      }
    }
  }

  public cancel(filter?: TypeKeyIdFeaturesPair) {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IStore) => {
      const sourcesEdits: TypeKeyIdFeaturesPair = {}
      const changes = getStore().edits
      if (!filter) {
        filter = {...changes.edits}
      }
      const edits = {...changes.edits}
      for (const id in changes.originals) {
        if (filter[id]) {
          sourcesEdits[id] = {}
          for (const featId in changes.originals[id]) {
            if (filter[id][featId]) {
              if (edits[id] && edits[id][featId]) {
                delete edits[id][featId]
              }
              if (changes.originals[id][featId]) {
                if (changes.originals[id][featId].status == FeatureStatus.New) {
                  //not sure if I should just remove the new fearutes everywhere on cancel...
                  changes.originals[id][featId].status = FeatureStatus.Deleted
                }
                sourcesEdits[id][featId] = changes.originals[id][featId]
              }
            }
          }
          if (edits[id] && Object.keys(edits[id]).length == 0) {
            delete edits[id]
          }
        }
      }
      // let newOriginals: TypeKeyIdFeaturesPair = {}
      // for(let id in edits){
      //     if(changes.originals[id]){
      //         newOriginals[id]= {};
      //         for(let featId in edits[id]){
      //             if(changes.originals[id][featId]){
      //                 newOriginals[id][featId] = changes.originals[id][featId]
      //             }
      //         }
      //     }

      // }
      dispatch({
        type: EditsActions.SET_SOURCE_EDITS,
        payload: edits
      })
      // dispatch({
      //     type: EditsActions.SET_SOURCE_ORIGINALS,
      //     payload: newOriginals
      // })
      console.warn(sourcesEdits)
      dispatch(this.dispatchAll(sourcesEdits))
    }
  }

  // protected seekOriginals(store: IStore, notFound: {[id: string]: {[key: string]: any}}, changes: TypeKeyIdFeaturesPair): TypeKeyIdFeaturesPair{
  //     let originalFeatures: TypeKeyIdFeaturesPair = {};
  //     for(let id in changes){
  //         if(!originalFeatures[id]){
  //             originalFeatures[id] = {}
  //         }
  //         for(let guid in changes[id]){
  //             if(notFound[id] && notFound[id][guid]){//make sure its searched for
  //                 if(changes[id][guid].status == FeatureStatus.New){
  //                     originalFeatures[id][guid] = changes[id][guid];
  //                 }
  //             }

  //         }
  //     }
  //     for(let id in store.data.featureTables){
  //         if(notFound[id]){
  //             let data = store.data.featureTables[id].data;
  //             if(data){
  //                 for(let i = 0; i < data.length; i ++){
  //                     let f = data[i];
  //                     if(notFound[id][f.getId()]){
  //                         if(!originalFeatures[id]){
  //                             originalFeatures[id] = {}
  //                         }
  //                         originalFeatures[id][f.getId()] = f.clone();
  //                         delete notFound[id][f.getId()];
  //                         if(Object.keys(notFound[id]).length == 0){
  //                             delete notFound[id];
  //                             break;
  //                         }
  //                     }
  //                 }
  //             }
  //         }
  //     }

  //     if(store.data.singleViewSelectedFeature){
  //         if(notFound[store.data.singleViewSelectedFeature.id]){
  //             let f = store.data.singleViewSelectedFeature.feature;
  //             if(!originalFeatures[store.data.singleViewSelectedFeature.id]){
  //                 originalFeatures[store.data.singleViewSelectedFeature.id] = {}
  //             }
  //             originalFeatures[store.data.singleViewSelectedFeature.id][f.getId()] = f.clone();
  //             delete notFound[store.data.singleViewSelectedFeature.id][f.getId()];
  //             if(Object.keys(notFound[store.data.singleViewSelectedFeature.id]).length == 0){
  //                 delete notFound[store.data.singleViewSelectedFeature.id];
  //             }
  //         }
  //     }
  //     if(store.map.popup && store.map.popup.data){
  //         for(let i = 0; i < store.map.popup.data.length; i++){
  //             if(notFound[store.map.popup.data[i].id]){
  //                 let id = store.map.popup.data[i].id;
  //                 let f = store.map.popup.data[i].feature;
  //                 if(!originalFeatures[id]){
  //                     originalFeatures[id] = {}
  //                 }
  //                 originalFeatures[id][f.getId()] = f.clone();
  //                 delete notFound[id][f.getId()];
  //                 if(Object.keys(notFound[id]).length == 0){
  //                     delete notFound[id];
  //                     break;
  //                 }
  //             }
  //         }
  //     }
  //     return originalFeatures;
  // }

  public applyChanges(changes: TypeKeyIdFeaturesPair, targets?: number) {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IStore) => {
      const sourcesEdits: TypeKeyIdFeaturesPair = {}
      const originals: TypeKeyIdFeaturesPair = {}
      const originalIdsToSeek: {[id: string]: {[key: string]: any}} = {}
      const store = getStore()
      for (const id in changes) {
        const change = changes[id]
        sourcesEdits[id] = {...store.edits.edits[id]}
        originals[id] = {...store.edits.originals[id]}
        for (const featId in change) {
          if (change[featId].status == FeatureStatus.Unchanged) {
            change[featId].status = FeatureStatus.Modified
          }
          sourcesEdits[id][featId] = change[featId]
        }
        for (const id in sourcesEdits) {
          for (const guid in sourcesEdits[id]) {
            if (!originals[id] || !originals[id][guid]) {
              if (!originalIdsToSeek[id]) {
                originalIdsToSeek[id] = {}
              }
              originalIdsToSeek[id][guid] = {}
            }
          }
        }
        //first set originals then change statuses
        if (Object.keys(originalIdsToSeek).length > 0) {
          // dispatch(this.setOriginals(this.seekOriginals(store, originalIdsToSeek, changes)))
          // throw new Error("Cant find originals for some entities");
          console.warn('Cant find originals for some entities')
        }
        // for(let id in sourcesEdits){
        //     for(let guid in sourcesEdits[id]){
        //         if(sourcesEdits[id][guid].status == FeatureStatus.Unchanged){
        //             sourcesEdits[id][guid].status = FeatureStatus.Modified;
        //         }
        //     }
        // }
      }

      dispatch({
        type: EditsActions.ADD_OR_UPDATE_SOURCE_EDITS,
        payload: sourcesEdits
      })

      ServiceHub.gisCrudService.updateEdits({...store.edits.edits, ...sourcesEdits})
      dispatch(this.dispatchAll(sourcesEdits, targets))
    }
  }

  protected getApplyEditsFromPendingEdits(
    currentEdits: TypeKeyIdFeaturesPair,
    layerInfos: IFeatureLayerInfos
  ): ISourceApplyEdits[] {
    const applyEditsFilter: ISourceApplyEdits[] = []
    for (const id in currentEdits) {
      const layerInfo = layerInfos[id]
      if (layerInfo) {
        const adds: Feature[] = []
        const updates: Feature[] = []
        const deletes: Feature[] = []
        for (const featId in currentEdits[id]) {
          if (currentEdits[id][featId].status == FeatureStatus.New) {
            adds.push(currentEdits[id][featId])
          } else if (currentEdits[id][featId].status == FeatureStatus.Modified) {
            updates.push(currentEdits[id][featId])
          } else if (currentEdits[id][featId].status == FeatureStatus.Deleted) {
            deletes.push(currentEdits[id][featId])
          }
        }
        applyEditsFilter.push({layerInfo, adds, updates, deletes})
      }
    }
    return applyEditsFilter
  }

  protected tryThrowApplyEditsError(applyEditsFilter: ISourceApplyEdits[], currentEdits: TypeKeyIdFeaturesPair): void {
    applyEditsFilter.forEach(a => {
      const storeSourceEdits = currentEdits[a.layerInfo.url]

      if (a.adds && a.adds.length > 0) {
        if (!storeSourceEdits) {
          throw new Error(`Cant find ${a.layerInfo.url} in store.edits.edits`)
        }
        a.adds.forEach(add => {
          if (!storeSourceEdits[add.getId()]) {
            throw new Error(`Cant find ${add.getId()} from adds in store.edits.edits[${a.layerInfo.url}]`)
          }
        })
      }
      if (a.updates && a.updates.length > 0) {
        if (!storeSourceEdits) {
          throw new Error(`Cant find ${a.layerInfo.url} in store.edits.edits`)
        }
        a.updates.forEach(update => {
          if (!storeSourceEdits[update.getId()]) {
            throw new Error(`Cant find ${update.getId()} from updates in store.edits.edits[${a.layerInfo.url}]`)
          }
        })
      }
    })
  }
  public refreshPendingChanges() {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IStore) => {}
  }

  public applyRemoteFirstEdits(
    applyEditsFilter?: ISourceApplyEdits[],
    callback?: (applyEdits: ISourceApplyEdits[]) => void,
    errorCallback?: (error: Error) => void
  ) {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IStore) => {
      const store = getStore()
      if (!applyEditsFilter) {
        applyEditsFilter = this.getApplyEditsFromPendingEdits(store.edits.edits, store.layerInfos.featureLayerInfos)
      } else {
        this.tryThrowApplyEditsError(applyEditsFilter, store.edits.edits)
      }
    }
  }

  protected afterApplyEdits(afterApplyEdits: ISourceApplyEdits[]) {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IStore) => {
      const store = getStore()
      const edits = {...store.edits.edits}
      const originals = {...store.edits.originals}
      const changes: TypeKeyIdFeaturesPair = {}

      const requestAddPromises: Promise<{features: Feature[]; info: FeatureLayerInfo}>[] = []

      afterApplyEdits.forEach(sourceEdits => {
        if (sourceEdits.adds && sourceEdits.adds.length > 0) {
          requestAddPromises.push(
            new Promise((res, rej) => {
              ServiceHub.gisCrudService
                .execute(sourceEdits.layerInfo, {
                  where: `"${sourceEdits.layerInfo.sourceDescription.idField}" IN (${sourceEdits
                    .adds!.map(a => a.getId())
                    .join(', ')})`
                })
                .then(r => {
                  res({features: r, info: sourceEdits.layerInfo})
                })
                .catch(e => {
                  rej(e)
                })
            })
          )
        }
      })
      Promise.all(requestAddPromises).then(r => {
        afterApplyEdits.forEach(sourceEdits => {
          changes[sourceEdits.layerInfo.url] = {}
          if (sourceEdits.adds) {
            const infoRequestedAdds = r.find(
              i => i.info.sourceDescription.id == sourceEdits.layerInfo.sourceDescription.id
            )

            sourceEdits.adds.forEach(add => {
              if (infoRequestedAdds) {
                const temp = infoRequestedAdds.features.find(f => f.getId() == add.getId())
                if (temp) {
                  add = temp
                }
              }
              changes[sourceEdits.layerInfo.url][add.guid] = add // when working with new features we always use guids not getId() since getId() changes value
              if (originals[sourceEdits.layerInfo.url]) originals[sourceEdits.layerInfo.url][add.guid] = add
              if (edits[sourceEdits.layerInfo.url]) delete edits[sourceEdits.layerInfo.url][add.guid]
            })
          }
          if (sourceEdits.updates)
            sourceEdits.updates.forEach(update => {
              changes[sourceEdits.layerInfo.url][update.getId()] = update
              if (originals[sourceEdits.layerInfo.url]) originals[sourceEdits.layerInfo.url][update.getId()] = update
              if (edits[sourceEdits.layerInfo.url]) delete edits[sourceEdits.layerInfo.url][update.getId()]
            })
          if (sourceEdits.deletes)
            sourceEdits.deletes.forEach(del => {
              changes[sourceEdits.layerInfo.url][del.getId()] = del
              originals[sourceEdits.layerInfo.url] && delete originals[sourceEdits.layerInfo.url][del.getId()]
              edits[sourceEdits.layerInfo.url] && delete edits[sourceEdits.layerInfo.url][del.getId()]
            })
          if (edits[sourceEdits.layerInfo.url] && Object.keys(edits[sourceEdits.layerInfo.url]).length == 0) {
            delete edits[sourceEdits.layerInfo.url]
          }
          if (originals[sourceEdits.layerInfo.url] && Object.keys(originals[sourceEdits.layerInfo.url]).length == 0) {
            delete originals[sourceEdits.layerInfo.url]
          }

          dispatch(this.dispatchAll(changes))
          dispatch({
            type: EditsActions.SET_SOURCE_EDITS,
            payload: edits
          })
          dispatch({
            type: EditsActions.SET_SOURCE_ORIGINALS,
            payload: originals
          })
        })
      })
    }
  }

  public applyEdits(
    applyEditsFilter?: ISourceApplyEdits[],
    callback?: (applyEdits: ISourceApplyEdits[]) => void,
    errorCallback?: (error: Error) => void
  ) {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IStore) => {
      const store = getStore()
      if (!applyEditsFilter) {
        applyEditsFilter = this.getApplyEditsFromPendingEdits(store.edits.edits, store.layerInfos.featureLayerInfos)
      } else {
        try {
          this.tryThrowApplyEditsError(applyEditsFilter, store.edits.edits)
        } catch (e) {
          if (errorCallback) {
            errorCallback(e)
          } else {
            throw e
          }
        }
      }
      ServiceHub.gisCrudService
        .applyEdits(applyEditsFilter)
        .then(r => {
          if (callback) callback(r)
          setTimeout(() => {
            //give some time for the callback component to do their stuff.. set state for example.. before updating them with props received
            dispatch(this.afterApplyEdits(r))
          }, 100)
        })
        .catch(e => {
          if (errorCallback) errorCallback(e)
        })
    }
  }

  protected applySingleViewChanges(sourcesEdits: TypeKeyIdFeaturesPair) {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IStore) => {
      const store = getStore()
      if (store.data.singleViewSelectedFeature && sourcesEdits[store.data.singleViewSelectedFeature.id]) {
        const feat =
          sourcesEdits[store.data.singleViewSelectedFeature.id][store.data.singleViewSelectedFeature.feature.getId()]
        if (feat) {
          dispatch({
            type: DataActions.SET_SINGLE_VIEW_SELECTED_FEATURE,
            payload: {
              feature: feat.clone(),
              id: store.data.singleViewSelectedFeature.id
            }
          })
        }
      }
    }
  }

  protected applySingleCreatorChanges(sourcesEdits: TypeKeyIdFeaturesPair) {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IStore) => {
      const store = getStore()
      if (store.data.singleCreateSelectedFeature && sourcesEdits[store.data.singleCreateSelectedFeature.id]) {
        if (
          sourcesEdits[store.data.singleCreateSelectedFeature.id][
            store.data.singleCreateSelectedFeature.feature.getId()
          ]
        ) {
          dispatch({
            type: DataActions.SET_SINGLE_CREATE_SELECTED_FEATURE,
            payload: {
              feature:
                sourcesEdits[store.data.singleCreateSelectedFeature.id][
                  store.data.singleCreateSelectedFeature.feature.getId()
                ].clone(),
              id: store.data.singleCreateSelectedFeature.id
            }
          })
        }
      }
    }
  }

  protected applyMapChanges(sourcesEdits: TypeKeyIdFeaturesPair) {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IStore) => {
      const layerInfos = getStore().layerInfos.featureLayerInfos
      for (const id in sourcesEdits) {
        if (layerInfos[id]) {
          getMapService().editing.syncSource(sourcesEdits[id], layerInfos[id])
        }
      }
    }
  }

  protected applyPopupChanges(sourcesEdits: TypeKeyIdFeaturesPair) {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IStore) => {
      const popupStore = {...getStore().map.popup}
      if (popupStore.data) {
        const data = [...popupStore.data]
        data.forEach(d => {
          if (sourcesEdits[d.id] && sourcesEdits[d.id][d.feature.getId()]) {
            d.feature = sourcesEdits[d.id][d.feature.getId()]
          }
        })
        popupStore.data = data
        dispatch({
          type: MapActions.SET_POPUP_PROPERTIES,
          payload: popupStore
        })
      }
    }
  }

  protected applyTableChanges(sourcesEdits: TypeKeyIdFeaturesPair) {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IStore) => {
      const store = getStore()
      const affectedFeatureTables: {
        [key: string]: ITableProps
      } = {}
      for (const key in store.data.featureTables) {
        if (sourcesEdits[key] && store.data.visibleTables[key]) {
          affectedFeatureTables[key] = store.data.featureTables[key]
        }
      }
      const changesTables: {
        [key: string]: ITableProps
      } = {}
      for (const key in affectedFeatureTables) {
        const tableProps = {...affectedFeatureTables[key]}

        if (tableProps.data) {
          const data = [...tableProps.data]
          const changes: {[i: number]: Feature} = {}
          data.forEach((d: Feature, i) => {
            const changedFeature = sourcesEdits[key][d.getId()]
            if (changedFeature) {
              changes[i] = changedFeature
            }
          })
          for (const i in changes) {
            data[i] = changes[i]
          }
          tableProps.data = data
        }
        changesTables[key] = tableProps
      }
      if (Object.keys(changesTables).length > 0) {
        dispatch({
          type: DataActions.ADD_ASYNC_TABS,
          payload: changesTables
        })
      }
    }
  }
}
